export const APP_VERSION = '0.5.0-dev';
